import { createStore }              from 'redux';
import rootSaga                     from '../middlewares/saga';
import middleware                   from '../middlewares';
import composeEnhancers             from './enhancers';
import reducer                      from './reducer-combiner';

const store = createStore(reducer, composeEnhancers(
    middleware.store
));

middleware.saga.run(rootSaga);

export default store;